import { render, staticRenderFns } from "./PhotoList.vue?vue&type=template&id=2988410e&scoped=true&"
import script from "./PhotoList.vue?vue&type=script&lang=js&"
export * from "./PhotoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2988410e",
  null
  
)

export default component.exports